// extracted by mini-css-extract-plugin
export default {"dottedBorderLeft":"mx3fuojj3xuUbN9ch3eB"};